module.exports = __webpack_public_path__ + "img/stock2.e059abf5.png";